module.exports = XMLHttpRequest;